module.exports = __webpack_public_path__ + "img/down_icon.5832c940.png";